import { Component, OnInit, ViewChild } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  EditService, IFilter, PageService, SortService } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay, map } from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { LegalDateTimeService } from './../../../services/legal-datetime.service';


@Component({
  selector: 'app-jobs-closed',
  templateUrl: './jobs-closed.component.html',
  styleUrls: ['./jobs-closed.component.css'],
  providers: [ToolbarService, ExcelExportService, EditService, ToolbarService, PageService, FilterService, SortService]
})
export class JobsClosedComponent implements OnInit {

  job_table: any;
  result: any;
  client_name: any;
  persons: any;
  job_table2: any;
  client_name_value: any;
 responseDelay = 2000;
  clients: any;
  clientLocalRecord: any;
  job_types: any;
  subjects: any;
  agents_assigned: any;
  staffList: any;
  items: Object[];
  data_subjects2: any;
  initialPage: PageSettingsModel;

  jobTypesLocalRecord: any;
  changeObject: any;

  subjectLocalRecord: any;

  createdAt: any;
  nextDateLocalRecord: any;

  agentsAssignedLocalRecord: any;
  allocated_agents_list: any;

  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 200 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  
  // sortOptions: { columns: { field: string; direction: string; }[]; };


  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  // @ViewChild('grid')
  // public grid: GridComponent;
  @ViewChild('grid', { static: true }) public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  today = new Date();

  job_table3: any; // filtered results of job table2 to load properly
  brands: any;
  brandsLocalRecord: any;
  brandLocalRecord: any;
  subject_agents_assigned: any;
  subjectsAssignedLocalRecord: any;
  allocated_agents_subject_list: any;
  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  sortOptions: Object;

  constructor(
    private http: HttpClient, private router: Router, route: ActivatedRoute,private _demoService: DemoService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
    public legalDate: LegalDateTimeService
  ) {


// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


   }

  ngOnInit() {
    // this.mapJobTableLive(); // load the table data
  
this.getJobsTableDataClosed();


    this.toolbarOptions = ['ExcelExport', 'Search'];
    this.initialPage = { pageSize:200 };
    this.filterOptions = {
      type: 'Menu'
   };
  //  this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
   this.formatOptions= {type:'date', format:'dd/MM/yyyy'};

   this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
   // this.groupOptions = { }; // sets auto grouping for the grid

    this.formatoptions = {type:'date', format:'dd/MM/yyyy'};
    this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.filter = { params: { format: this.dateFormat } };
   
   
    this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };

  }



  created(args) { 
    // bind the groupsetting in grid’s created event  
        // this.grid.groupSettings = { 
        //   columns: ['job_order'] 
        // }; 
        // this.grid.sortSettings = { columns: [{ field: 'job_order', direction: 'Descending' } ] };
      } 


// New way of rendering table data
mapJobTableLive() {

  this.getClients(); // load clients first
  this.getJobTypes();
  this.getJobSubjectsAll();
  this.getBrandUsers('94'); // for sharmans only
  this.getJobAgentsAllAssigned();
  this.getBrands(); //
  this.getJobAgentsAllAssigned();
  this.getSubjectAgentsAssignedAll();


  this.http.get<any>(this.gfunc.apiURL + '/job/table/all/closed')
 .pipe(map(data => {
  // do your transformations
  this.job_table2 = data;

  this.job_table2.forEach(element => {

// local Client Name
/*
this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
let rs = this.clientLocalRecord;
this.changeObject = Object.assign(this.clientLocalRecord);
element.client_id  = this.changeObject[0].name;
*/
// get brand_report_id // client brand Name
this.brandLocalRecord = this.brands.filter(c => c.brand_id === element.brand_report_id);
this.changeObject = Object.assign(this.brandLocalRecord);
element.brand_report_id  = this.changeObject[0].name;

// Get Job Types
this.jobTypesLocalRecord = this.job_types.filter(c => c.job_type_id === element.job_type_id);
this.changeObject = Object.assign(this.jobTypesLocalRecord);
element.job_type_id  = this.changeObject[0].job_type_name;
// Get Job Subject Name
this.subjectLocalRecord = this.subjects.filter(c => c.subject_id === element.subject_id);
this.changeObject = Object.assign(this.subjectLocalRecord);
if (this.changeObject[0].first_name === null){
 // element.subject_id = '-';
  element.subject_name = '-';
}else{
 // element.subject_id  = this.changeObject[0].first_name + ' ' + this.changeObject[0].surname;
element.subject_name = this.changeObject[0].first_name + ' ' + this.changeObject[0].surname;
}

this.setLegalGridDateFields(element);
// Agents Assigned
// this.agentsAssignedLocalRecord = this.agents_assigned.filter(c => c.job_id === element.job_id); // old version
this.agentsAssignedLocalRecord = this.subject_agents_assigned.filter(c => c.subject_id === element.subject_id);
this.changeObject = Object.assign(this.agentsAssignedLocalRecord);
let recordCount = this.changeObject.length;
console.log(recordCount);
this.allocated_agents_list = '';
if (recordCount < 1){
  this.allocated_agents_list = '-';
}else{
  for (let i = 0; i < recordCount; i++) {
this.allocated_agents_list  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
} // end loop
}
element.allocated_to  = this.allocated_agents_list;



}); // end for each of all


return this.job_table3;
})
 ) // end map
  .subscribe(results => this.job_table3 = results
  );

}






// get the mapping stuff

getClients() {
  this._demoService.getClients().subscribe(
     data => { this.clients = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

// need to get new clients
getBrands() {
  this._demoService.getBrands().subscribe(
     data => { this.brands = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobSubjectsAll() {
  this._demoService.getJobSubjectsAll().subscribe(
     data => { this.subjects = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobAgentsAllAssigned() {
  this._demoService.getJobAgentsAllAssigned().subscribe(
     data => { this.agents_assigned = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getSubjectAgentsAssignedAll(){
  this._demoService.getSubjectAgentsAssignedAll().subscribe(
    data => { this.subject_agents_assigned = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
 }





// gets the list of users assiciated for drop down.
getBrandUsers(brand_id) {
  this._demoService.getBrandUsers(brand_id).subscribe(
     data => { this.staffList = data;
    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }




 toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}



jobLink(job_id) {
  // this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
  this.gfunc.globalJobEditStep3(job_id);
}

jobView(job_id) {
  // this.router.navigate(['/admin/jobs/view/' + job_id + '']);
  this.gfunc.globalJobView(job_id);
}

subjectEdit(subject_id){
  // this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
  this.gfunc.globalJobSubjectView(subject_id);
}


refreshGrid(){ // refresh the databutton
  //this.mapJobTableLive();
  this.getJobsTableDataClosed();
  this.grid.refresh();
};





getJobsTableDataClosed() {
  this._demoService.getJobsTableDataClosed().subscribe(
    data => { this.subjects_urgent = data;
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      this.subjects_urgent = DataUtil.parse.parseJson(data); 
      this.subjects_urgent.forEach((row) => this.setLegalGridDateFields(row));
     // console.log("Done loadng USER");
     // console.log(this.users);


    },
    error => {
    //  console.error('Error Loading User!');
    // return Observable.throw(error);
    }
  ); }

private setLegalGridDateFields(element: any): void {
['next_date', 'final_date', 'hearing_date', 'judgement_date', 'filing_date', 'instructions_date', 'aos_date']
  .forEach((field) => {
    element[`${field}_display`] = this.legalDate.format(element[field], 'DD/MM/YYYY h:mm a');
    element[`${field}_search`] = this.legalDate.format(element[field], 'YYYY-MM-DD');
  });
}




// https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    //console.log(pdfdata.results);
    
   // this.search_results = pdfdata.records; // need this if a grouping is set.
  /*   this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

};




// End Grid Items and Setup





sortComparer(reference: string, comparer: string) { 
  // This will be triggered for comparing each value with the reference value 
  // This can be customized to compare the values as per your need and return the corresponding result 

  let r: number = +reference
  let c: number = +comparer
  
  if (r < c) { 
    // console.log('reference ' + reference)  
    // console.log('comparer ' + comparer)  
    return -1; 
      
  } 
  if (r > c) { 
    // console.log('reference gtr ' + reference)  
    // console.log('comparer grt' + comparer)  
      return 1; 
  } 
  //was 0
  return 0; 
} 





}
